export default __webpack_public_path__ + "static/media/student_wave.85454f2a.svg";